import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OperationSplitPage } from './operation-split';
import { TextMaskModule } from 'angular2-text-mask';
import { SharedModule } from '../../shared/shared.module';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OperationSplitPage
  ],
  imports: [
    IonicPageModule.forChild(OperationSplitPage),
    TextMaskModule,
    SharedModule,
    DropDownListModule,
    DirectivesModule,
  ],
})
export class OperationSplitPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/operation-split/operation-split.module.ts